import React from 'react';
import { useParams } from 'react-router-dom';
import { mockPlaylists, mockSongs } from '../data/mockData';
import { Play, Heart, MoreHorizontal, Clock } from 'lucide-react';

const PlaylistDetail = ({ onPlaySong }) => {
  const { id } = useParams();
  const playlist = mockPlaylists.find((p) => p.id === id || p.id === `playlist-${id}`);

  if (!playlist) {
    return (
      <div className="flex-1 flex items-center justify-center bg-gradient-to-br from-gray-50 via-white to-blue-50">
        <p className="text-gray-500 text-lg font-medium">Playlist no encontrada</p>
      </div>
    );
  }

  const playlistSongs = mockSongs.filter((song) => playlist.songs.includes(song.id));

  return (
    <div className="flex-1 overflow-y-auto pb-32 bg-gradient-to-br from-gray-50 via-white to-blue-50">
      {/* Playlist Header */}
      <div className="relative bg-gradient-to-r from-[#056A84] via-[#00CCFF] to-[#056A84] overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse"></div>
        </div>
        <div className="relative px-8 pt-20 pb-8">
          <div className="flex items-end gap-8">
            <img
              src={playlist.cover}
              alt={playlist.name}
              className="w-64 h-64 rounded-2xl shadow-2xl object-cover transform transition-transform duration-300 hover:scale-105"
            />
            <div className="flex-1">
              <p className="text-sm font-bold text-white uppercase mb-2 tracking-wider">Playlist</p>
              <h1 className="text-6xl font-black text-white mb-4 drop-shadow-lg">{playlist.name}</h1>
              <p className="text-white/90 text-xl mb-4 font-medium">{playlist.description}</p>
              <div className="flex items-center gap-3 text-sm text-white font-medium">
                <span className="font-bold">Tu Iglesia App</span>
                <span>•</span>
                <span>{playlistSongs.length} canciones</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="bg-gradient-to-b from-white/50 to-transparent px-8 py-6">
        <div className="flex items-center gap-4">
          <button
            onClick={() => playlistSongs.length > 0 && onPlaySong(playlistSongs[0], playlistSongs)}
            className="w-16 h-16 bg-gradient-to-r from-[#00CCFF] to-[#056A84] rounded-full flex items-center justify-center hover:scale-110 transition-all duration-300 shadow-xl"
          >
            <Play size={28} className="text-white ml-1" fill="white" />
          </button>
          <button className="text-gray-600 hover:text-[#00CCFF] transition-all duration-300 hover:scale-110">
            <Heart size={36} />
          </button>
          <button className="text-gray-600 hover:text-[#00CCFF] transition-all duration-300 hover:scale-110">
            <MoreHorizontal size={36} />
          </button>
        </div>
      </div>

      {/* Track List */}
      <div className="px-8 pb-8">
        <div className="mb-4">
          <div className="grid grid-cols-[40px_1fr_1fr_80px] gap-4 px-4 py-3 border-b border-gray-300 text-sm text-gray-600 uppercase font-bold">
            <span>#</span>
            <span>Título</span>
            <span>Álbum</span>
            <span className="flex items-center justify-center">
              <Clock size={16} />
            </span>
          </div>
        </div>

        <div className="space-y-2">
          {playlistSongs.map((song, index) => (
            <div
              key={song.id}
              onClick={() => onPlaySong(song, playlistSongs)}
              className="grid grid-cols-[40px_1fr_1fr_80px] gap-4 px-4 py-3 rounded-xl hover:bg-white transition-all duration-300 cursor-pointer group shadow-sm hover:shadow-md"
            >
              <div className="flex items-center">
                <span className="text-gray-500 group-hover:hidden font-medium">{index + 1}</span>
                <Play
                  size={18}
                  className="hidden group-hover:block text-[#00CCFF]"
                  fill="#00CCFF"
                />
              </div>
              <div className="flex items-center gap-3 min-w-0">
                <img src={song.cover} alt={song.title} className="w-12 h-12 rounded-lg shadow-md" />
                <div className="min-w-0">
                  <p className="text-gray-900 font-bold truncate">{song.title}</p>
                  <p className="text-sm text-gray-500 truncate">{song.artist}</p>
                </div>
              </div>
              <div className="flex items-center">
                <p className="text-gray-500 text-sm truncate">{song.album}</p>
              </div>
              <div className="flex items-center justify-center">
                <span className="text-gray-500 text-sm font-medium">{song.duration}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlaylistDetail;
